import React from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, X } from 'lucide-react';

const RoleChangeConfirmModal = ({ isOpen, onConfirm, onCancel, newRole }) => {
    if (!isOpen) return null;
    if (typeof document === 'undefined') return null;

    return createPortal(
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-slideUp">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4 text-center relative">
                    <button
                        onClick={onCancel}
                        className="absolute top-4 right-4 w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-all"
                    >
                        <X size={18} className="text-white" />
                    </button>
                    <div className="flex justify-center mb-3">
                        <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                            <AlertTriangle size={40} className="text-white" />
                        </div>
                    </div>
                    <h2 className="text-2xl font-bold text-white mb-2">
                        Confirm Role Change
                    </h2>
                    <p className="text-blue-100">
                        You are about to switch to <strong>{newRole}</strong>
                    </p>
                </div>

                {/* Content */}
                <div className="p-6">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                        <p className="text-blue-800 text-sm flex items-start gap-2">
                            <span className="text-blue-600 font-bold text-lg">ℹ️</span>
                            <span>
                                <strong>Important:</strong> Changing your role will:
                            </span>
                        </p>
                        <ul className="mt-2 ml-6 text-blue-800 text-sm space-y-1 list-disc">
                            <li>Navigate you to the first menu item</li>
                            <li>Clear your current view and any unsaved changes</li>
                            <li>Change your access permissions and available features</li>
                        </ul>
                    </div>

                    <p className="text-gray-600 text-sm mb-4">
                        Are you sure you want to continue?
                    </p>
                </div>

                {/* Footer */}
                <div className="bg-gray-50 px-6 py-4 flex items-center justify-end gap-3 border-t border-gray-200">
                    <button
                        onClick={onCancel}
                        className="px-6 py-2.5 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-all font-semibold border border-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all font-semibold shadow-md hover:shadow-lg"
                    >
                        Change Role
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default RoleChangeConfirmModal;
